module.exports = "/static/Images/pt-br/One.png";